import { adjust, assoc, compose, evolve, insert, insertAll, remove } from 'ramda';

import { assignOriginalIdToBlocks } from 'utils/blocksHelpers';

import * as types from './types';

export const addBlocksInsidePage = ({
  blockOrBlocks,
  data,
  pageIndex,
  blockIndex,
}: types.AddBlocksInsidePageProps): types.Page[] => {
  const blocksArray = Array.isArray(blockOrBlocks) ? blockOrBlocks : [blockOrBlocks];

  const updatedBlocks = insertAll(blockIndex + 1, blocksArray, data.pages[pageIndex].blocks);
  const newBlocksWithFakeIds = assignOriginalIdToBlocks(updatedBlocks);

  const updatedPages = adjust(pageIndex, evolve({ blocks: () => newBlocksWithFakeIds }), data.pages);

  return updatedPages;
};

export const editBlockInsidePage = ({ pageIndex, blockIndex, newBlock, data }: types.EditBlockInsidePageProps) => {
  const replaceBlock = compose(remove<types.CommonBlock>(blockIndex, 1), insert(blockIndex + 1, newBlock));
  const updatedPages = adjust(pageIndex, evolve({ blocks: replaceBlock }), data.pages);

  return updatedPages;
};

export const removeBlockInsidePage = ({ pageIndex, blockIndex, data }: types.RemoveBlockInsidePageProps) => {
  const blocks = adjust<types.CommonBlock>(blockIndex, assoc('_destroy', true));
  const updatedPages = adjust(pageIndex, evolve({ blocks }), data.pages);

  return updatedPages;
};
